import { render, staticRenderFns } from "./UsersGrid.vue?vue&type=template&id=14828b12&"
import script from "./UsersGrid.vue?vue&type=script&lang=js&"
export * from "./UsersGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports